export function Timeline2026({isOpen}){

    return ( 

    <div
        style={{
          display: "flex",

          listStyle: 'none',
          overflow: 'hidden',
          maxHeight: isOpen ? '10000px' : '0',
          transition: 'max-height 0.5s ease',
          width: "100%",
          justifyContent: "center"
          }}
      >
        <div className="table-container">
          <table>
            <tbody>
            <tr>
              <td className="year normal-glow-text">May 2026 - Present</td>
              <td>
                <a href="https://sqipqueue.com">
                <h3 >Founder & Full Stack Developer @</h3>
                <div className="mobile-container">
                  <h3 className="para-spacer">SqipQueue</h3>
                  <span className="mobile-year-para normal-glow-text">
                    May 2026 - Present
                  </span>
                </div>
                </a>

                <ul>
                  <li className="normal-glow-text">
                   Partnered with a team of developers to build a SaS product. 
                  </li>
                  <li className="normal-glow-text">
                Designed and developed a real-time customer-facing platform featuring live wait time tracking, mobile queue enrollment, and automated turn notifications to eliminate in-person wait uncertainty.
                  </li>
                  <li className="normal-glow-text">
                Engineered a unified walk-in and appointment management dashboard, streamlining front desk operations and reducing staff interruptions from status inquiries
                  </li>
                </ul>
                <div className="bottom-icons">
                  <div className="icon-tool-tip" data-tooltip="React">
                    <img
                      className="svg-glow"
                      src="/tech_icons/react.svg"
                      alt="Next js"
                      height="32px"
                      width="32px"
                    />
                  </div>

                  <div className="icon-tool-tip" data-tooltip="Django">
                    <img
                      className="svg-glow"
                      src="/tech_icons/django.svg"
                      alt="Cloud"
                      height="35px"
                      width="35px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Javascript">
                    <img
                      className="svg-glow"
                      src="/tech_icons/javascript.svg"
                      alt="Node js"
                      height="32px"
                      width="32px"
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td className="year normal-glow-text">Apr 2026</td>
              <td>
                <a href="https://barbellplan.org">
                  <h3>Full Stack Developer</h3>
                  <div className="mobile-container">
                    <h3 className="para-spacer">Barbell Workout Planner</h3>
                    <span className="mobile-year-para normal-glow-text">
                      Apr 2026
                    </span>
                  </div>
                </a>
                <ul>
                  <li className="normal-glow-text">
                Designed and deployed a full-stack fitness utility web app (barbellplan.org) that automates barbell warm-up weight calculations, eliminating manual math for gym-goers with a clean, mobile-responsive UI
                  </li>
                  <li className="normal-glow-text">
                Developed a user-focused workout planning tool from scratch, independently handling frontend design, backend logic, and production deployment.
                  </li>
                </ul>
                <div className="bottom-icons">
                  <div className="icon-tool-tip" data-tooltip="React">
                    <img
                      className="svg-glow"
                      src="/tech_icons/react.svg"
                      alt="Next js"
                      height="32px"
                      width="32px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Javascript">
                    <img
                      className="svg-glow"
                      src="/tech_icons/javascript.svg"
                      alt="Node js"
                      height="32px"
                      width="32px"
                    />
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
</table>
</div>
</div>
)
}
